module.exports = __webpack_public_path__ + "img/img6.13f50c41.png";